'use strict';

var React = require('react');
var createReactClass = require('create-react-class');
var accessibilityHelper = require('../../lib/ADAHelpers');
var LocalizeMixin = require('../../localization/CommonLocalizationMixin');

module.exports = createReactClass({
    displayName: 'exports',

    mixins: [LocalizeMixin],
    handleCloseClick: function handleCloseClick() {
        this.props.hideGenericModal();
    },
    componentDidMount: function componentDidMount() {
        accessibilityHelper.focusOnElementAfterModalTransition('#okay-button', 'open');
    },
    handleKeyDown: function handleKeyDown(e) {
        accessibilityHelper.keepTrappedInModal(e, document.querySelector('#dialog-modal'), document.querySelector('#okay-button'));
    },
    render: function render() {
        return React.createElement(
            'div',
            { className: 'generic-dialog-modal', id: 'dialog-modal', role: 'dialog', 'aria-labelledby': 'modal-title', 'aria-describedby': 'modal-text', tabIndex: '0', onKeyDown: this.handleKeyDown },
            React.createElement(
                'div',
                { className: 'modal-header' },
                React.createElement(
                    'button',
                    { type: 'button', className: 'close', onClick: this.handleCloseClick },
                    React.createElement(
                        'span',
                        { 'aria-hidden': 'true' },
                        '\xD7'
                    ),
                    React.createElement(
                        'span',
                        { className: 'sr-only' },
                        this.getLocalizedText("modal_close")
                    )
                )
            ),
            React.createElement(
                'div',
                { id: 'modal-body', className: 'modal-body content' },
                React.createElement(
                    'div',
                    { className: 'row' },
                    React.createElement(
                        'div',
                        { className: 'col-xs-12' },
                        React.createElement(
                            'h4',
                            { id: 'modal-title' },
                            this.props.title
                        ),
                        React.createElement('hr', null),
                        React.createElement(
                            'p',
                            { id: 'modal-text' },
                            this.props.text
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'col-xs-12' },
                        React.createElement('input', { id: 'okay-button', type: 'button', role: 'button', className: 'btn btn-primary qa-generic-dialog-ok', value: 'OK', onClick: this.handleCloseClick })
                    )
                )
            )
        );
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/findLocationComponents/Dialog.js
// module id = 800
// module chunks = 0